import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { INDICATOR_SUMMARY_QUESTION_ID } from '../NPOFeedback/utils';
import { Question } from './Components/Beneficiary/BeneficiaryLanding';
import { Answer } from './Components/Review/utils';

const HAS_OWN_SUMMARY = [5];
const SUMMARY_ID: { [key: number]: number } = {
  5: 40015,
};

export const getDebugNavigationQuestionId = (
  sectionId: number,
  optionId: number,
  currentSection: FeedbackSectionId,
  questions: Question[],
  currentSectionAnswers: Answer[],
): number | null => {
  if (sectionId === 0 && HAS_OWN_SUMMARY.indexOf(optionId) > -1) {
    const nextQuestion = questions.filter(
      q => q.dbId === SUMMARY_ID[optionId],
    )?.[0];
    return nextQuestion.dbId;
  }
  let lastQuestionId: number | null = null;
  if (currentSection === 'dates') {
    lastQuestionId = (currentSectionAnswers || [])?.filter(
      ans => ans?.questionId === 10003,
    )?.[0]?.questionId;
  }
  if (!lastQuestionId && currentSection === 'indicator_details') {
    return INDICATOR_SUMMARY_QUESTION_ID;
  }
  if (!lastQuestionId) {
    lastQuestionId = currentSectionAnswers?.slice(-1)?.[0]?.questionId;
  }
  return lastQuestionId || null;
};

export const getNavigationQuestionId = (
  sectionId: number,
  optionId: number,
  currentSection: FeedbackSectionId,
  questions: Question[],
  currentSectionAnswers: Answer[],
) => {
  return (
    currentSectionAnswers[0]?.questionId ||
    getDebugNavigationQuestionId(
      sectionId,
      optionId,
      currentSection,
      questions,
      currentSectionAnswers,
    )
  );
};
